(ns frontend.ui.component.lp-portal.report.body.invest-europe.holding.new-investment.pdf.view
  (:require
   [common.util :as cu]
   [frontend.ui.component.lp-portal.voima-components.pdf.card.view :as card]
   [frontend.ui.component.lp-portal.voima-components.pdf.column.view :as column]
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.report.component.block-table.pdf-view :as block-table-pdf]
   [frontend.ui.component.lp-portal.report.component.horizontal-table.pdf-view :as horizontal-table-pdf]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
   [frontend.ui.page.lp-portal.report.pdf.view :as pdf-report]))

(defn- new-investment-info-figures
  [{:keys [investment-info]}]
  (block-table-pdf/table investment-info))

(defn image
  [data]
  (when-not (cu/blank-value? (:image data))
    (card/card
     ""
     {:image (str (:image data))
      :width 200}
     (text-content/optional-footer data))))

(defn new-investment-company-page-1
  [data]
  (let [{:keys [overview-new holding-name image-1 ownership-new]} data]
    (page/page
     (page/third-column-background-full-height-not-rounded)
     (page/page-title-with-line {:page-title (str holding-name " - New investment") :toc-item true})
     (column/columns-2-to-1
      (card/card
       ""
       (text-content/rich-content (->> overview-new
                                       :case-overview
                                       :rich-content))
       (column/columns
        (image image-1)
        (card/card ""
                   (horizontal-table-pdf/table ownership-new)
                   (text-content/optional-footer ownership-new))))
      (card/card
       nil
       (new-investment-info-figures overview-new)
       (text-content/optional-footer (:investment-info overview-new)))))))

(defn new-investment-pages
  [data]
  (let []
    (when-not (cu/blank-value? (:reference-date data))
      (concat [(new-investment-company-page-1 data)]))))

(defn pdf-report
  [{:keys [reporting-period holding-name reference-date] :as view-data}]
  (pdf-report/report view-data
                     (new-investment-pages view-data)
                     holding-name
                     reporting-period
                     reference-date))
